module.exports = __webpack_public_path__ + "static/media/Catalogo-Monedero.869920cf.png";